import React from 'react';
import { BUTTONS, EditIcon } from 'wix-rich-content-plugin-commons';
import { updateLinkAtCurrentSelection, getEntityData, insertCustomLink } from 'wix-rich-content-editor-common';
import TextLinkButton from './TextLinkButton.js';
import RemoveLinkButton from './RemoveLinkButton.js';
import UrlLinkButton from './UrlLinkButton.js';
import 'prop-types';
import '../types.js';
import 'lodash';
import '../icons/RemoveLinkIcon.js';
import 'classnames';
import '../link-viewer-54ef808f.js';
import 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const createInlineButtons = (config) => {
  return [
    {
      keyName: "url",
      component: (props) => /* @__PURE__ */ React.createElement(UrlLinkButton, __spreadValues(__spreadValues({}, config), props)),
      mobile: true,
      type: BUTTONS.CUSTOM
    },
    { keyName: "separator1", type: BUTTONS.SEPARATOR, mobile: true },
    {
      keyName: "edit",
      component: (props) => /* @__PURE__ */ React.createElement("div", { "data-hook": "EditLinkButton", style: { margin: "0 2px 0 -7px" } }, /* @__PURE__ */ React.createElement(
        TextLinkButton,
        __spreadValues(__spreadValues({
          insertLinkFn: updateLinkAtCurrentSelection,
          getEntityData,
          insertCustomLink,
          icon: EditIcon,
          tooltipText: config.t("LinkTo_Edit_Tooltip")
        }, config), props)
      )),
      mobile: true,
      type: BUTTONS.CUSTOM
    },
    { keyName: "separator2", type: BUTTONS.SEPARATOR, mobile: true },
    {
      keyName: "remove",
      component: (props) => /* @__PURE__ */ React.createElement("div", { style: { margin: "0 -6px 0 -6px" } }, /* @__PURE__ */ React.createElement(RemoveLinkButton, __spreadValues(__spreadValues({}, config), props))),
      mobile: true,
      type: BUTTONS.CUSTOM
    }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
